import { Country } from '@afterpay/types'
import { ConsumerAddress, isShippingAddress, ShippingAddress } from '../model'

export interface ContactAddress {
  name: string
  line1: string
  line2: string
  area1: string
  area2: string
  region: string
  postcode: string
  countryCode: Country
  phoneNumber: string
}

export const transformAddressToContact = (address: ConsumerAddress | ShippingAddress): ContactAddress => {
  const transformedAddressToContactObject = {
    name: address.name,
    line1: address.address1,
    line2: address.address2,
    area1: address.suburb,
    area2: address.area2,
    region: address.state,
    postcode: address.postcode,
    countryCode: address.countryCode,
    phoneNumber: isShippingAddress(address) ? address.phoneNumber : '',
  }

  // @ts-expect-error: OPERATION BLEED STOPPER
  return transformedAddressToContactObject
}
